export type MigrationState =
  | 'pending'
  | 'in_progress'
  | 'blocked'
  | 'failed'
  | 'completed'
  | 'unknown';

export const MIGRATION_STATES: readonly MigrationState[] = [
  'pending',
  'in_progress',
  'blocked',
  'failed',
  'completed',
  'unknown',
];

export type MigrationAccountState =
  | 'pending'
  | 'blocked'
  | 'conflict'
  | 'retry_later'
  | 'plan_ready'
  | 'applied'
  | 'verified'
  | 'completed'
  | 'verify_failed'
  | 'failed'
  | 'unknown';

export enum MigrationAccountType {
  MAIN = 1,
  EVAL = 2,
  FUNDED = 3,
}

export type MigrationAccountResponse = {
  address: string;
  account_type: MigrationAccountType;
  state: MigrationAccountState;
  /** Unix milliseconds. */
  updated_at: number;
};

export type MigrationStatusResponse = {
  bundle_id: string;
  state: MigrationState;
  accounts: MigrationAccountResponse[];
};

export type MigrationOptInResponse = {
  bundle_id: string;
  state: MigrationState;
};

export type MigrationStatus =
  | {
      started: true;
      bundleId: string;
      state: MigrationState;
      accounts: string[];
    }
  | { started: false };
